import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M21.283 2.471A.6.6 0 0 1 21.6 3v14.4a.6.6 0 0 1-.267.5l-5.4 3.6a.6.6 0 0 1-.63.021L9.3 18.091l-6.002 3.43A.6.6 0 0 1 2.4 21V6.6a.6.6 0 0 1 .302-.52l6.3-3.6a.6.6 0 0 1 .596 0l5.978 3.415 5.091-3.394a.6.6 0 0 1 .616-.03ZM15 6.948 9.9 4.034v13.018l5.1 2.914V6.948Zm1.2 12.93 4.2-2.8V4.122l-4.2 2.8V19.88Zm-7.5-2.826V4.034L3.6 6.948v13.018l5.1-2.914Z"
      clip-rule="evenodd"
    />
  </svg>
`;
